<template>
    <v-container grid-list-md fluid>
        <div v-if="isAuthorized && startMonthlyDates.length && endMonthlyDates.length">
            <v-row class="pb-1" no-gutters>
                <!-- <v-col cols="2">
                    <v-btn

                        color="secondary"
                        @click="download()"
                        elevation="0"
                        block
                        height="40px"
                        class="rounded-lg gradient"
                    >Télécharger</v-btn>
                </v-col> -->

                <v-col cols="2">
                    <v-btn-primary @click="accountingBookletDialog = true" block
                        >Télécharger</v-btn-primary
                    >
                </v-col>
                <v-col cols="3" class="pl-2 d-flex">
                    <v-select
                        v-model="firstPeriodStart"
                        :items="startMonthlyDates"
                        label="Date de début"
                        elevation="0"
                        hide-details
                        :disabled="
                            notOnly6And7 ||
                            (!!selectedAccountingClosing && !!selectedAccountingClosing.id)
                        "
                        data-cy="DashboardAccounting-dateDebut"
                        density="compact"
                    />
                    <v-select
                        v-model="firstPeriodEnd"
                        :items="endMonthlyDates"
                        label="Date de fin"
                        elevation="0"
                        hide-details
                        :disabled="
                            !firstPeriodStart ||
                            (!!selectedAccountingClosing && !!selectedAccountingClosing.id)
                        "
                        class="pl-2"
                        data-cy="DashboardAccounting-dateFin"
                        density="compact"
                    />
                </v-col>
                <v-col
                    cols="1"
                    v-if="!$vuetify.display.mobile"
                    class="d-flex justify-end align-center px-0 mx-0 flex-grow-0 flex-shrink-1"
                    style="max-width: 50px"
                >
                    <v-btn
                        size="x-small"
                        variant="text"
                        @click="clearFilter()"
                        class="btn-filter"
                        data-cy="DashboardAccounting-delete"
                    >
                        <v-icon medium>$delete</v-icon>
                    </v-btn>
                </v-col>
                <v-col
                    :cols="step === 'OperatingAccountFromPartition' ? 2 : 1"
                    class="d-flex justify-center pl-1 flex-grow-1 flex-shrink-0"
                    :style="$vuetify.display.mobile ? '' : 'min-width: 130px;'"
                >
                    <v-select
                        v-model="comparisonType"
                        :items="comparisonTypes"
                        label="Afficher N-1"
                        elevation="0"
                        hide-details
                        :disabled="disableDisplayNMoinsUn"
                        data-cy="DashboardAccounting-n1"
                        density="compact"
                    />
                </v-col>
                <v-col
                    cols="1"
                    class="d-flex justify-center align-center flex-grow-1 flex-shrink-0"
                    :style="$vuetify.display.mobile ? '' : 'min-width: 105px;'"
                    v-if="step !== 'OperatingAccountFromPartition'"
                >
                    <v-checkbox
                        v-model="displayMonthlyData"
                        label="Mensuel"
                        hide-details
                        density="compact"
                        :disabled="disableDisplayMonthlyData"
                    >
                    </v-checkbox>
                </v-col>
                <v-col cols="2" v-if="budgets.length && step !== 'OperatingAccountFromPartition'">
                    <v-select
                        outlined
                        :items="budgets"
                        item-text="name"
                        item-value="id"
                        :model-value="budgets[selectedBudget].name"
                        :hide-details="true"
                        density="compact"
                        :append-inner-icon="'arrow_drop_down'"
                        @update:model-value="updateSelectedBudget"
                        :item-title="(item) => item.name"
                    />
                </v-col>
                <v-col
                    cols="2"
                    v-if="
                        !$vuetify.display.mobile &&
                        step !== 'OperatingAccountFromPartition' &&
                        step !== 'Bilan'
                    "
                >
                    <oss-tags-selector
                        v-model="tags"
                        :items="usedTags"
                        :label="'Filtrer par étiquettes'"
                        class="pl-2"
                        :itemTitle="(item) => item.text"
                    />
                </v-col>
            </v-row>

            <v-tabs v-model="step" fixed-tabs style="border-radius: 16px; overflow: hidden">
                <v-tab
                    value="Flash"
                    href="#Flash"
                    v-if="done(OA_FlashSituation)"
                    data-cy="DashboardAccounting-flash"
                >
                    <strong>Flash</strong></v-tab
                >
                <v-tab
                    value="SIG"
                    href="#SIG"
                    v-if="!isAccountingClientUser && done(OA_SIG)"
                    data-cy="DashboardAccounting-sig"
                >
                    <strong>SIG</strong></v-tab
                >
                <v-tab
                    value="Bilan"
                    href="#Bilan"
                    v-if="!isAccountingClientUser && OA_BalanceSheet && OA_BalanceSheet.length"
                    data-cy="DashboardAccounting-bilan"
                    ><strong>Bilan</strong></v-tab
                >
                <v-tab
                    value="1"
                    href="#1"
                    v-if="
                        !isAccountingClientUser && OA_IncomeStatement && OA_IncomeStatement.length
                    "
                    data-cy="DashboardAccounting-compteResultat"
                >
                    <strong>Compte de résultat</strong></v-tab
                >
                <!-- <template v-for="(partitionTag, index) in partitionTags">
                    <v-tab :key="index+'_partitionTag'" :href="'#' + index"><strong>{{ partitionTag.title }}</strong></v-tab>
                </template> -->
                <v-tab
                    value="OperatingAccountFromPartition"
                    href="#OperatingAccountFromPartition"
                    v-if="partitionTags && partitionTags.length"
                    ><strong>Tableau analytique</strong></v-tab
                >
                <v-tab value="4" href="#4" v-if="custom_OA && custom_OA.length"
                    ><strong>Tableau personnalisé</strong></v-tab
                >
            </v-tabs>
            <v-tabs-window v-model="step">
                <v-window-item value="Flash">
                    <v-row class="d-flex justify-center pt-4">
                        <v-col cols="8" class="pa-0">
                            <v-select
                                v-model="selectorOaFlashSituation"
                                :items="OA_FlashSituation"
                                item-value="id"
                                label="Choisissez votre compte d'exploitation"
                                background-color="white"
                                hide-details
                                class="pb-1"
                                width="80vm;"
                                v-if="OA_FlashSituation && OA_FlashSituation.length > 1"
                                density="compact"
                                :item-title="(item) => item.name"
                            >
                            </v-select>
                        </v-col>
                    </v-row>
                    <AccountingTable
                        ref="Flash"
                        :operatingAccountId="selectorOaFlashSituation"
                        :myKey="'Flash'"
                        :currentKey="step"
                        :options="options[step]"
                        :periods="periods"
                        :tags="tagIds"
                        :displayMonthlyData="displayMonthlyData"
                        :round="true"
                        :withSelector="OA_FlashSituation && OA_FlashSituation.length > 1"
                    >
                    </AccountingTable>
                </v-window-item>
                <v-window-item value="SIG">
                    <v-row class="d-flex justify-center pt-4">
                        <v-col cols="8" class="pa-0">
                            <v-select
                                v-model="selectorOaSIG"
                                :items="OA_SIG"
                                item-value="id"
                                label="Choisissez votre compte d'exploitation"
                                background-color="white"
                                hide-details
                                width="80vm;"
                                class="pb-1"
                                v-if="OA_SIG && OA_SIG.length > 1"
                                density="compact"
                                :item-title="(item) => item.name"
                            >
                            </v-select>
                        </v-col>
                    </v-row>
                    <AccountingTable
                        ref="SIG"
                        :myKey="'SIG'"
                        :currentKey="step"
                        :options="options[step]"
                        :operatingAccountId="selectorOaSIG"
                        :periods="periods"
                        :tags="tagIds"
                        :displayMonthlyData="displayMonthlyData"
                        :withSelector="OA_SIG && OA_SIG.length > 1"
                        :round="true"
                    >
                    </AccountingTable>
                </v-window-item>

                <v-window-item value="1">
                    <v-row class="d-flex justify-center pt-4">
                        <v-col cols="8" class="pa-0">
                            <v-select
                                v-model="selectorOaIncomeStatement"
                                :items="OA_IncomeStatement"
                                item-value="id"
                                label="Choisissez votre compte d'exploitation"
                                background-color="white"
                                hide-details
                                width="80vm;"
                                class="pb-1"
                                v-if="OA_IncomeStatement && OA_IncomeStatement.length > 1"
                                density="compact"
                                :item-title="(item) => item.name"
                            >
                            </v-select>
                        </v-col>
                    </v-row>
                    <AccountingTable
                        :options="options[step]"
                        :operatingAccountId="selectorOaIncomeStatement"
                        :myKey="'1'"
                        :currentKey="step"
                        ref="1"
                        :periods="periods"
                        :tags="tagIds"
                        :displayMonthlyData="displayMonthlyData"
                        :withSelector="OA_IncomeStatement && OA_IncomeStatement.length > 1"
                        :round="true"
                    >
                    </AccountingTable>
                </v-window-item>
                <v-window-item value="Bilan">
                    <v-row class="d-flex justify-center pt-4">
                        <v-col cols="8" class="pa-0">
                            <v-select
                                v-model="selectorOaBalanceSheet"
                                :items="OA_BalanceSheet"
                                item-value="id"
                                label="Choisissez votre compte d'exploitation"
                                background-color="white"
                                hide-details
                                class="pb-1"
                                width="80vm;"
                                v-if="OA_BalanceSheet && OA_BalanceSheet.length > 1"
                                density="compact"
                                :item-title="(item) => item.name"
                            >
                            </v-select>
                        </v-col>
                    </v-row>
                    <AccountingTable
                        :options="options[step]"
                        :operatingAccountId="selectorOaBalanceSheet"
                        :myKey="'Bilan'"
                        :currentKey="step"
                        ref="Bilan"
                        :periods="periods"
                        :tags="tagIds"
                        :displayMonthlyData="displayMonthlyData"
                        :withSelector="OA_BalanceSheet && OA_BalanceSheet.length > 1"
                        :round="true"
                    >
                    </AccountingTable>
                    <!-- <AccountingTable
                    :options="options[step]"
                    :myKey="'Bilan'"
                    :currentKey="step"
                    ref="Bilan"
                    :periods="periods"
                    :tags="tagIds"
                    >
                    </AccountingTable> -->
                </v-window-item>
                <v-window-item
                    value="OperatingAccountFromPartition"
                    v-if="partitionTags && partitionTags.length"
                >
                    <OperatingAccountFromPartition
                        ref="OperatingAccountFromPartition"
                        :periods="periods"
                        :partitionTags="partitionTags"
                        :operatingAccountJsons="operatingAccountJsons"
                        :round="true"
                        @emittedDataFromOAFP="handleDataFromOAFP"
                    >
                    </OperatingAccountFromPartition>
                </v-window-item>
                <v-window-item value="4" v-if="custom_OA && custom_OA.length">
                    <v-row class="d-flex justify-center pt-4">
                        <v-col cols="8" class="pa-0">
                            <v-select
                                v-model="selectorCustomOA"
                                :items="custom_OA"
                                item-value="id"
                                label="Choisissez votre compte d'exploitation"
                                background-color="white"
                                hide-details
                                class="pb-1"
                                width="80vm;"
                                v-if="custom_OA.length > 1"
                                density="compact"
                                :item-title="(item) => item.name"
                            >
                            </v-select>
                        </v-col>
                    </v-row>
                    <AccountingTable
                        :options="options[step]"
                        :operatingAccountId="selectorCustomOA"
                        :myKey="'4'"
                        :currentKey="step"
                        ref="4"
                        :periods="periods"
                        :tags="tagIds"
                        :displayMonthlyData="displayMonthlyData"
                        :withSelector="custom_OA.length > 1"
                        v-if="selectorCustomOA"
                    >
                    </AccountingTable>
                </v-window-item>
                <!-- <v-window-item key="5" value="5">
                    <AccountingTable
                    :options="options[step]"
                    :myKey="'5'"
                    :currentKey="step"
                    ref="5"
                    :periods="periods"
                    :tags="tagIds"
                    >
                    </AccountingTable>
                </v-window-item> -->
            </v-tabs-window>
            <AccountingBooklet
                v-model="accountingBookletDialog"
                :tabFather="options[step]"
                :startDateFather="firstPeriodStart"
                :endDateFather="firstPeriodEnd"
                :optionsFather="optionsExport"
                v-if="accountingBookletDialog"
                :tagsFather="tags"
                :usedTagsFather="usedTags"
                :partitionTags="partitionTags"
                :periods="periods"
                :dataFromOAFP="dataFromOAFP"
            />
        </div>
    </v-container>
</template>

<script lang="ts">
import { Apollo } from "@/decorators";
import moment from "moment-timezone";

import AccountingTable from "./AccountingTable.vue";
import OperatingAccountFromPartition from "./OperatingAccountFromPartition.vue";

import USED_TAG_QUERY from "../../graphql/tag/UsedTags.gql";
import PARTITION_TAG_QUERY from "../../graphql/tag/CompanyPartitionTags.gql";
import OPERATING_ACCOUNT_QUERY from "../../graphql/tag/OperatingAccounts.gql";
import SCENARIO_NAMES from "../../graphql/budget/BudgetScenario.gql";
import ACCOUNTING_COMPANY_OF_COMPANY from "../../graphql/company/AccountingCompanyOfCompany.gql";
import ACCOUNTING_FIRM_CLIENT from "../../graphql/billing/AccountingFirmClient.gql";

import { getCompanyTags } from "../../services/tagServices";

import AccountingBooklet from "./AccountingBooklet.vue";
import {
    getAccountingPeriodEndMonths,
    getAccountingPeriodStartMonths,
} from "../../services/accountingPeriods";
import { User } from "../../store/store";
import { checkAccessRights } from "../../services/accessRightServices";
import { statSheetNotOnly6And7 } from "../../../../backend/src/common/dashboard/dashboardTable";
import { Component, Vue, toNative } from "vue-facing-decorator";
import { Watch } from "vue-facing-decorator";

@Component({
    components: {
        AccountingTable,
        // BalanceSheet,
        OperatingAccountFromPartition,
        AccountingBooklet,
    },
})
export class DashboardAccounting extends Vue {
    step = "Flash";

    firstPeriodStart: string = "";
    firstPeriodEnd: string = "";

    // selectedPartitionTags = []
    id;
    selectorOaSIG = "";
    selectorOaIncomeStatement = "";
    selectorOaBalanceSheet = "";
    selectorOaFlashSituation = "";
    selectorCustomOA = "";

    tags = [];

    accountingBookletDialog = false;

    displayMonthlyData = false;
    disableDisplayMonthlyData = false;

    selectedBudget: number = 0;
    // selectedPeriod: number = 1;
    // periodsList = [];

    apolloFinished = false;

    comparisonType = 1;
    comparisonTypes = [
        {
            value: 0,
            title: "Sans",
        },
        {
            value: 1,
            title: "Période complète",
        },
        {
            value: 2,
            title: "Même période que N",
        },
    ];

    options = {
        SIG: {
            title: "Solde intermédiaire de gestion",
            className: "OperatingAccountCustom",
            type: "SIG",
            accountingPeriodRequired: false,
        },
        "1": {
            title: "Compte de résultat",
            className: "OperatingAccountCustom",
            type: "INCOME_STATEMENT",
            accountingPeriodRequired: false,
        },
        Bilan: {
            title: "Bilan",
            className: "OperatingAccountCustom",
            type: "BALANCE_SHEET",
            accountingPeriodRequired: true,
        },
        OperatingAccountFromPartition: {},
        "4": {
            title: this.selectorCustomOA,
            className: "OperatingAccountCustom",
            type: "MISCELLANEOUS",
            accountingPeriodRequired: false,
        },
        // "5": { title: "Tableau de financement", className:'CashFlowStatement',   accountingPeriodRequired: true},
        Flash: {
            title: "Flash",
            className: "OperatingAccountCustom",
            type: "FLASH_SITUATION",
            accountingPeriodRequired: false,
        },
    };

    dataFromOAFP: { selectedTable: string; selectedPartition: string; selectedTags: string[] } = {
        selectedTable: null,
        selectedPartition: null,
        selectedTags: [],
    };

    get currentUser(): User {
        return this.$store.state.user;
    }

    get isAuthorized() {
        const authorized = checkAccessRights(this.currentUser, "accounting", "dashboard");
        return authorized;
    }

    get selectedCompany() {
        return this.$store.state.selected_company || null;
    }

    get selectedCompanyId() {
        return this.selectedCompany?.id || "";
    }

    get tagIds() {
        return this.tags.map((t) => t.id);
    }

    get periods() {
        const periods = [];
        if (this.firstPeriodStart && this.firstPeriodEnd) {
            periods.push({
                // start: this.step === 'Bilan' ? undefined: moment(this.firstPeriodStart).format("YYYY-MM-DD"),
                start: moment(this.firstPeriodStart).format("YYYY-MM-DD"),
                end: moment(this.firstPeriodEnd).format("YYYY-MM-DD"),
                monthly: this.displayMonthlyData,
                accountingPeriodId: this.selectedAccountingPeriod.id,
                accountingClosingId: this.selectedAccountingClosing?.id || undefined,
            });
        }
        const previousAccountingPeriodId = this.getPreviousAccountingPeriod();
        if (this.displayNMoinsUn && previousAccountingPeriodId) {
            let start = moment(this.firstPeriodStart).subtract(1, "years").format("YYYY-MM-DD");
            let end = moment(this.firstPeriodEnd).subtract(1, "years").format("YYYY-MM-DD");
            if (this.comparisonType === 1) {
                start = moment(this.selectedAccountingPeriod.start)
                    .subtract(1, "years")
                    .format("YYYY-MM-DD");
                end = moment(this.selectedAccountingPeriod.end)
                    .subtract(1, "years")
                    .format("YYYY-MM-DD");
            }
            periods.push({
                // start: this.step === 'Bilan' ? undefined : start,
                start,
                end,
                accountingPeriodId: previousAccountingPeriodId,
                type: "nMoinsUn",
            });
        }
        if (this.selectedBudget) {
            if (this.budgets[this.selectedBudget].id === "freeBudget") {
                periods.push({
                    // start,
                    // end,
                    type: "freeBudget",
                    // budgetId: this.budgets[this.selectedBudget].id,
                });
            } else if (this.budgets[this.selectedBudget].id) {
                let start = moment(this.firstPeriodStart).format("YYYY-MM-DD");
                let end = moment(this.firstPeriodEnd).format("YYYY-MM-DD");
                if (this.comparisonType === 1) {
                    start = this.selectedAccountingPeriod.start;
                    end = this.selectedAccountingPeriod.end;
                }
                periods.push({
                    start,
                    end,
                    type: "budget",
                    budgetId: this.budgets[this.selectedBudget].id,
                });
            }
        }
        return periods;
    }

    clearFilter() {
        this.displayMonthlyData = false;
        this.comparisonType = 0;
        this.updateFirstPeriod();
    }

    get companyId() {
        return this.$store.state.selected_company.id;
    }

    get selectedAccountingPeriod() {
        return this.$store.state.accountingPeriod.selectedAccountingPeriod;
    }

    get accountingPeriods() {
        return this.$store.state.accountingPeriod.accountingPeriods;
    }

    get disableDisplayNMoinsUn() {
        if (this.accountingPeriods?.length >= 2) {
            return false;
        }
        return true;
    }

    get displayNMoinsUn() {
        if (this.comparisonType && this.accountingPeriods?.length >= 2) {
            return true;
        }
        return false;
    }

    get selectedAccountingClosing() {
        return this.$store.state.accountingPeriod.selectedAccountingClosing;
    }

    get disableEndDateSelector() {
        if (this.selectedAccountingPeriod) {
            return false;
        }
        return true;
    }

    get startMonthlyDates() {
        return getAccountingPeriodStartMonths(
            this.selectedAccountingPeriod,
            this.accountingAvailabilityDate,
        );
    }

    get endMonthlyDates() {
        return getAccountingPeriodEndMonths(
            this.selectedAccountingPeriod,
            this.accountingAvailabilityDate,
        );
    }

    get optionsExport() {
        const result: any = {};
        if (this.displayNMoinsUn) {
            result.displayNMinusOne = true;
            if (this.comparisonType === 1) {
                result.displayNMinusCompletePeriod = true;
            }
        }
        if (this.displayMonthlyData) {
            result.displayMonthly = true;
        }
        if (this.selectedBudget) {
            result.budgetFather = this.selectedBudget;
        }
        return result;
    }

    get OA_SIG() {
        if (this.operatingAccountJsons) {
            const result = this.operatingAccountJsons.filter((e) => e.type === "SIG");
            if (result && result.length) {
                this.selectorOaSIG = result[0].id;
            }
            return result;
        }
        return [];
    }

    get OA_IncomeStatement() {
        if (this.operatingAccountJsons) {
            const result = this.operatingAccountJsons.filter((e) => e.type === "INCOME_STATEMENT");
            if (result && result.length) {
                this.selectorOaIncomeStatement = result[0].id;
            }
            return result;
        }
        return [];
    }

    get OA_BalanceSheet() {
        if (this.operatingAccountJsons) {
            const result = this.operatingAccountJsons.filter((e) => e.type === "BALANCE_SHEET");
            if (result && result.length) {
                this.selectorOaBalanceSheet = result[0].id;
            }
            return result;
        }
        return [];
    }

    get OA_FlashSituation() {
        if (this.operatingAccountJsons) {
            const result = this.operatingAccountJsons.filter((e) => e.type === "FLASH_SITUATION");
            if (result && result.length) {
                this.selectorOaFlashSituation = result[0].id;
            }
            return result;
        }
        return [];
    }

    get custom_OA() {
        if (this.operatingAccountJsons) {
            const result = this.operatingAccountJsons.filter((e) => e.type === "MISCELLANEOUS");
            if (result && result.length) {
                this.selectorCustomOA = result[0].id;
            }
            return result;
        }
        return [];
    }

    get notOnly6And7() {
        if (this.step === "Bilan") {
            return true;
        }
        if (this.step === "4" && this.selectorCustomOA) {
            const selectedOA = this.custom_OA.find(
                (element) => element.id === this.selectorCustomOA,
            );
            if (selectedOA?.accountableAccountFilter) {
                statSheetNotOnly6And7(selectedOA.accountableAccountFilter);
            }
        }
        return false;
    }

    @Watch("step")
    @Watch("selectorCustomOA")
    updatePeriodWhenBalance() {
        if (this.notOnly6And7) {
            this.firstPeriodStart =
                this.selectedAccountingPeriod && this.startMonthlyDates?.length
                    ? this.startMonthlyDates?.[0].value
                    : undefined;
            this.displayMonthlyData = false;
            this.disableDisplayMonthlyData = true;
        } else {
            this.disableDisplayMonthlyData = false;
        }
    }

    @Watch("startMonthlyDates")
    @Watch("selectedAccountingPeriod")
    @Watch("selectedAccountingClosing")
    updateFirstPeriod() {
        this.firstPeriodStart =
            this.selectedAccountingPeriod && this.startMonthlyDates?.length
                ? this.startMonthlyDates[0].value
                : undefined;
        if (this.selectedAccountingClosing?.id) {
            const month = moment(this.selectedAccountingClosing.endDate).format("YYYY-MM-DD");
            const date = this.endMonthlyDates.find((d) => d.value === month);
            if (date) {
                this.firstPeriodEnd = date.value;
            } else {
                this.firstPeriodEnd = undefined;
            }
        } else {
            this.firstPeriodEnd =
                this.selectedAccountingPeriod && this.endMonthlyDates.length
                    ? this.endMonthlyDates[this.endMonthlyDates.length - 1].value
                    : undefined;
        }
    }

    @Apollo({
        query: ACCOUNTING_COMPANY_OF_COMPANY,
        variables() {
            return {
                companyId: this.selectedCompanyId,
            };
        },
        skip() {
            return !this.isAuthorized || !this.currentUser.company?.id;
        },
        specificResult({ data, loading, networkStatus }: any) {
            if (!loading) {
                if (data && data.companies && data.companies.length) {
                    this.dbAccountingFirm = data.companies[0];
                }
            }
        },
    })
    dbAccountingFirm = null;

    get accountingFirm() {
        if (this.dbAccountingFirm) {
            return this.dbAccountingFirm;
        }
        if (this.selectedCompany?.accountingFirm) {
            return this.selectedCompany;
        }
        return this.selectedCompany;
    }

    @Apollo({
        query: ACCOUNTING_FIRM_CLIENT,
        variables() {
            return {
                clientId: this.selectedCompanyId,
                accountingFirmId: this.accountingFirm.id,
            };
        },
        skip() {
            return !this.isAuthorized || !this.selectedCompanyId || !this.accountingFirm?.id;
        },
        specificResult({ data, loading, networkStatus }: any) {
            if (!loading) {
                if (data.accountingFirmClientFirst) {
                    this.accountingFirmClient = data.accountingFirmClientFirst;
                } else {
                    this.accountingFirmClient = null;
                }
            }
        },
    })
    accountingFirmClient = null;

    get isAccountingClientUser() {
        if (this.currentUser?.isBusinessClient) {
            return false;
        }
        if (this.currentUser?.isRoot) {
            return false;
        }
        if (!this.accountingFirm) {
            return true;
        }

        if (this.accountingFirm.id === this.currentUser.company.id) {
            return false;
        }
        return true;
    }

    get accountingAvailabilityDate() {
        if (this.isAccountingClientUser) {
            if (this.accountingFirmClient?.accountingAvailabilityDate) {
                return this.accountingFirmClient?.accountingAvailabilityDate;
            }
        }
        return null;
    }

    @Apollo({
        query() {
            return USED_TAG_QUERY;
        },
        variables() {
            return {
                companyId: this.companyId,
                mode: "all",
                filterTagDistribution: true,
            };
        },
        debounce: 500,
        skip() {
            return !this.isAuthorized || !this.companyId;
        },
        specificResult({ data, loading, networkStatus }: any) {
            if (!loading && data) {
                this.usedTags = [];
                if (data.usedTags && data.usedTags.tags) {
                    getCompanyTags(this, this.companyId, data.usedTags.tags, this.usedTags);
                }
                debugger;
            }
        },
    })
    usedTags = [];

    @Apollo({
        query() {
            return PARTITION_TAG_QUERY;
        },
        variables() {
            return {
                companyId: this.companyId,
            };
        },
        debounce: 500,
        skip() {
            return !this.isAuthorized || !this.companyId;
        },
        specificResult({ data, loading, networkStatus }: any) {
            if (!loading && data) {
                this.partitionTags = data.partitionTags;
            } else {
                this.partitionTags = [];
            }
        },
    })
    partitionTags = [];

    @Apollo({
        query() {
            return OPERATING_ACCOUNT_QUERY;
        },
        variables() {
            return {
                companyId: this.companyId,
                use: "OPERATING_ACCOUNT",
            };
        },
        skip() {
            return !this.isAuthorized || !this.companyId;
        },
        specificResult({ data, loading, networkStatus }: any) {
            if (!loading && data && data.scopingOperatingAccount) {
                for (const op of data.scopingOperatingAccount.data) {
                    op.title = op.name;
                }
                this.operatingAccountJsons = data.scopingOperatingAccount.data || [];
            } else {
                this.operatingAccountJsons = [];
            }
            this.apolloFinished = true;
        },
    })
    operatingAccountJsons = [];

    beforeMount() {
        this.updateFirstPeriod();
        if (this.disableDisplayNMoinsUn) {
            this.comparisonType = 0;
        }
    }

    @Apollo({
        query: SCENARIO_NAMES,
        variables() {
            return {
                companyId: this.companyId,
            };
        },
        skip() {
            return !this.isAuthorized || !this.companyId;
        },
        specificResult({ data, loading, networkStatus }: any) {
            this.loading = loading;
            if (!loading) {
                if (data?.budgets?.length) {
                    const budgets = JSON.parse(JSON.stringify(data.budgets));
                    budgets.unshift({
                        id: "freeBudget",
                        name: "Budget libre",
                        type: "freeBudget",
                        date: moment().format("YYYY-MM-DD"),
                    });
                    budgets.unshift({
                        id: "",
                        name: "Sans budget",
                        type: "",
                        date: moment().format("YYYY-MM-DD"),
                    });
                    this.budgets = budgets;
                    this.selectedBudget = 0;
                } else {
                    this.budgets = [];
                    this.budgets.unshift({
                        id: "freeBudget",
                        name: "Budget libre",
                        type: "freeBudget",
                        date: moment().format("YYYY-MM-DD"),
                    });
                    this.budgets.unshift({
                        id: "",
                        name: "Sans budget",
                        type: "",
                        date: moment().format("YYYY-MM-DD"),
                    });
                    this.selectedBudget = 0;
                }
            }
        },
    })
    budgets: Array<any> = [];

    formatedPeriod(start, end) {
        const result = moment(start).format("DD/MM/YYYY") + " - " + moment(end).format("MM/YYYY");
        return result;
    }

    getPreviousAccountingPeriod() {
        const index = this.accountingPeriods.findIndex(
            (e) => e.id === this.selectedAccountingPeriod.id,
        );
        if (index > 0) {
            return this.accountingPeriods[index - 1]?.id;
        }
        return null;
    }

    done(getterKey) {
        // fonction permettant de charger les premiers onglets en même temps que les autres et de les décharger s'ils sont vides pour éviter que l'onglet sur lequel s'ouvre la page soit le premier onglet chargé, sans controle de notre part
        if (this.apolloFinished && getterKey.length === 0) {
            return false;
        }
        return true;
    }

    handleDataFromOAFP(operatingAccountId, partitionTagId, selectedPath) {
        const selectedTagNames = selectedPath[0].selected.map((tag) => tag.name);
        const selectedTags = this.partitionTags[0].tags
            .filter((tag) => selectedTagNames.includes(tag.name))
            .map((tag) => tag.id);
        this.dataFromOAFP = {
            selectedTable: operatingAccountId,
            selectedPartition: partitionTagId,
            selectedTags: selectedTags,
        };
    }

    updateSelectedBudget(newId) {
        if (newId) {
            this.selectedBudget = this.budgets.findIndex((budget) => budget.id === newId);
        } else {
            this.selectedBudget = 0;
        }
    }
}

export default toNative(DashboardAccounting);
</script>
